module.exports = __webpack_public_path__ + "img/9788954430579.b3ee8dcf.jpg";